import * as ActionTypes from '../constants/actionTypes'
import moment from 'moment'
import { actionCreate, actionRead, actionUpdate, actionDelete } from '../api/action'

export const editForm = formFieldsChange => ({
  type: ActionTypes.ACTIONFORM_EDITFORM_CHANGE,
  field: formFieldsChange,
})

export const reset = () => ({
  type: ActionTypes.ACTIONFORM_ENTER_RESET,
})

export const fetchItem = values => (dispatch) => {
  dispatch({ type: ActionTypes.ACTIONFORM_FETCHITEM_LOAD })

  actionRead(values).then((res) => {
    const item = res.result

    const begin = item.d_begin ? moment(item.d_begin) : moment()
    const end = item.d_end ? moment(item.d_end) : moment()

    dispatch({
      type: ActionTypes.ACTIONFORM_EDITFORM_CHANGE,
      field: {
        id: { name: 'idnum', value: item.idnum },
        s_name: { name: 's_name', value: item.s_name },
        s_picture: { name: 's_picture', value: item.s_picture },
        s_descr: { name: 's_descr', value: item.s_descr },
        d_begin: { name: 'd_begin', value: begin },
        d_end: { name: 'd_end', value: end },
        b_infinity: { name: 'b_infinity', value: end.format('YYYY-MM-DD') === '2100-01-01' },
        n_max_amount: { name: 'n_max_amount', value: item.n_max_amount ? item.n_max_amount : 0 },
        n_discobonus: { name: 'n_discobonus', value: item.n_discobonus ? item.n_discobonus : '1' },
        n_sleep_bonus: { name: 'n_sleep_bonus', value: item.n_sleep_bonus },
        b_sleep_bonus: { name: 'b_sleep_bonus', value: item.n_sleep_bonus === '0' },
        n_fire_bonus: { name: 'n_fire_bonus', value: item.n_fire_bonus },
        b_fire_bonus: { name: 'b_fire_bonus', value: item.n_fire_bonus !== '0' },
        n_discount_type: { name: 'n_discount_type', value: item.n_discount_type },
        n_discount_value: { name: 'n_discount_value', value: item.n_discount_value },
        f_action_types: { name: 'f_action_types', value: item.f_action_types },
        s_values: { name: 's_values', value: item.s_values },
        s_sellers: { name: 's_sellers', value: item.s_sellers },
        n_enable: { name: 'n_enable', value: item.n_enable === '1' },
      },
    })
    dispatch({
      type: ActionTypes.ACTIONFORM_FETCHITEM_SUCCEED,
      item,
    })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.ACTIONFORM_FETCHITEM_FAIL,
      fetchItemError: 'Ошибка получения данных по акции.',
    })
  })
}

export const createItem = values => (dispatch) => {
  // console.log(values)
  dispatch({ type: ActionTypes.ACTIONFORM_CREATEITEM_LOAD })
  actionCreate(values).then(() => {
    dispatch({ type: ActionTypes.ACTIONLIST_CHANGETABLE_CHANGE })
    dispatch({ type: ActionTypes.ACTIONFORM_CREATEITEM_SUCCEED })
    dispatch({ type: ActionTypes.ACTIONFORM_ENTER_RESET })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.ACTIONFORM_CREATEITEM_FAIL,
      createItemError: 'Ошибка создания акции.',
    })
  })
}

export const editItem = params => (dispatch) => {
  dispatch({ type: ActionTypes.ACTIONFORM_EDITITEM_LOAD })

  params.n_enable = params.n_enable ? 1 : 0
  params.d_begin = moment(params.d_begin).format('YYYY-MM-DD')
  params.d_end = moment(params.d_end).format('YYYY-MM-DD')

  actionUpdate(params).then(() => {
    dispatch({ type: ActionTypes.ACTIONFORM_EDITITEM_SUCCEED })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.ACTIONFORM_EDITITEM_FAIL,
      editItemError: 'Ошибка изменения данных.',
    })
  })
}

export const deleteItem = values => (dispatch) => {
  dispatch({ type: ActionTypes.ACTIONFORM_DELETEITEM_LOAD })

  actionDelete(values).then(() => {
    dispatch({ type: ActionTypes.ACTIONFORM_DELETEITEM_SUCCEED })
    dispatch({ type: ActionTypes.ACTIONFORM_ENTER_RESET })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.ACTIONFORM_DELETEITEM_FAIL,
      deleteItemError: 'Ошибка удаления акции.',
    })
  })
}



// WEBPACK FOOTER //
// src/actions/actionForm.js